/* eslint-disable jsx-a11y/anchor-is-valid */
import { Box, Grid } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import React, { useEffect, useMemo } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'

import { renderRoute, useQueryParams } from '../../../../../util/utils'
import colors from '../../../../../assets/colors'

import { useHistory, useLocation } from 'react-router-dom'
import {
  fetchCashbackDetails,
  fetchCashbackExtract,
} from '../../CashbackExtractActions'
// import { Filter } from './Filter'
// import List from './List'
import BaseCreatePage from '../../../../../components/hooks/BaseCreatePage'
import { Filter } from './Filter'
import List from './List'
import { edit, fetchClientCashback } from '../../../../clients/ClientActions'
import { fetchLaundryClient } from '../../../point-value/PointValueActions'
import Tabs from '../../../../../components/hooks/BaseTabs/Tabs'
import Tab from '../../../../../components/hooks/BaseTabs/Tab'
import { mdiChartLineVariant, mdiArrowDown, mdiArrowUp } from '@mdi/js'

const ExtractDetails = props => {
  const permissions = useSelector(state => state.auth.permissions)
  const client = useSelector(state => state.client.editingClient)

  const { id: client_id } = props.match.params

  const location = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()

  const filters = useQueryParams(location?.search)

  const currentTab = useMemo(() => {
    if (!filters?.tab) return 0
    return Number(filters?.tab)
  }, [filters])

  const handleChangeTab = value => {
    history.replace(`${location.pathname}?tab=${value}`)
  }

  const fetchExtract = () => {
    const tabFilters = {
      0: {}, // Extrato completo
      1: {
        operation_type: 'received', // Recebidos (points > 0)
      },
      2: {
        operation_type: 'withdrawn', // Retirados (points < 0)
      },
    }

    const baseFilters = tabFilters[currentTab] || {}

    const finalFilters = {
      ...filters,
      ...baseFilters,
      client_id: client_id,
    }

    dispatch(fetchCashbackDetails(finalFilters))
  }

  useEffect(() => {
    if (!client_id || client?.id) return
    dispatch(edit(client_id))
    dispatch(fetchClientCashback(client_id))
    dispatch(fetchLaundryClient())
  }, [client_id])

  useEffect(() => {
    fetchExtract()
  }, [location, client_id])

  return (
    <BaseCreatePage
      page={'Extrato'}
      path={client?.name || 'Carregando...'}
      goBack
      hiddenReturn
    >
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Tabs>
              <Tab
                label="Extrato"
                value={currentTab}
                tabIndex={0}
                setValue={handleChangeTab}
                icon={mdiChartLineVariant}
                iconColor={colors.primary}
                removeNavigation={false}
              />
              <Tab
                label="Recebidos"
                value={currentTab}
                tabIndex={1}
                setValue={handleChangeTab}
                icon={mdiArrowDown}
                iconColor={colors.sucess}
                removeNavigation={false}
              />
              <Tab
                label="Retirados"
                value={currentTab}
                tabIndex={2}
                setValue={handleChangeTab}
                icon={mdiArrowUp}
                iconColor={colors.error}
                removeNavigation={false}
              />
            </Tabs>
          </Grid>

          <Grid item xs={12}>
            <Filter />
          </Grid>

          <Grid item xs={12}>
            <List />
          </Grid>
        </Grid>
      </Grid>
    </BaseCreatePage>
  )
}

export default ExtractDetails
